import { clearError } from '@/store/slices';
import { RootState } from '@/store/store';
import { useDispatch, useSelector } from 'react-redux';

export const useError = () => {
  const dispatch = useDispatch();
  const error = useSelector((state: RootState) => state.error);

  const dismissError = () => {
    dispatch(clearError());
  };

  return {
    error,
    dismissError
  };
};
